import { useQuery } from '@tanstack/react-query';

import { AWP_STALE_TIME, awpKeys, requestAwpVisits } from './awpApi';

/**
 * The member's AWP visit dates, newest first.
 *
 * Members only, until a visits query a physician can call exists: portals-api's `myAwpVisits` always
 * reads the signed-in member's own exams and refuses a provider token. So `memberId` isn't sent; it
 * gates the query (`User.memberId` is optional) and keys the cache, so one member's visits can never be
 * served to another.
 */
export function useAwpVisits(memberId: string | undefined) {
  return useQuery({
    queryKey: awpKeys.visits(memberId ?? ''),
    queryFn: ({ signal }) => requestAwpVisits(signal),
    enabled: Boolean(memberId),
    staleTime: AWP_STALE_TIME,
  });
}
